import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap"
import { Placement } from "react-bootstrap/esm/types"
import { DollarIcon, LocationIcon } from './icons';
import { formatMoney, toSentenceCase } from '../utils/index';
import { useNavigate } from "react-router-dom";
import { AppPagination } from "./filter";
import { joblistResponseType } from '../types/index';
import { useState } from "react";
const DEFAULT_URL = "https://www.pngfind.com/pngs/m/665-6659827_enterprise-comments-default-company-logo-png-transparent-png.png"


export default function JobList({ action, onJobSelect, jobList = [], pagination, redirectUrl = '', }: any) {
    const navigate = useNavigate();
    const [selectedJobId, setSelectedJobId] = useState(null);

    if (!jobList.length) {
        return <>No Data found</>
    }
    const getSkills = (arr: any[]) => {
        const temp = [...arr].map((item: any) => item.name);
        temp.splice(0, 1);
        return temp.join(",");
    }



    const Mobile = ({ value }: any) => {


        return <div onClick={() => { navigate(`${value._id}`) }} className="d-flex w-100 click main-joblist-mobile  mb-3  shadow-sm rounded p-4">
            <div className="d-flex flex-column w-100">
                <div className="row w-100 mb-3" style={{ marginLeft: 0, marginRight: 0 }}>
                    <div className="col-2 d-flex ">
                        <div className="job-logo rounded-5 shadow-sm" style={{ backgroundImage: `url('${value.companyImgUrl || DEFAULT_URL}')` }}></div>
                    </div>
                    <div onClick={() => { navigate(`${value._id}`) }} className="job-info-container list-items  col-5">
                        <p className="company-title">{value.companyName}</p>
                        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={ToolTip({ text: value?.jobRole?.name ||'' })}>
                            <h6 className="company-title">{toSentenceCase(value?.jobRole?.name||'')}</h6>
                        </OverlayTrigger>
                    </div>
                    <div className="col-5 d-flex list-items justify-content-between flex-column">
                        <Label classList={"mb-1"} text={toSentenceCase(value.location)} Icon={LocationIcon} />
                        {value.showSalary ? <Label text={`${formatMoney(value?.salaryLowerAmount)}-${formatMoney(value?.salaryUpperAmount)}`} Icon={null} /> : <Label text={`N/A`} Icon={null} />}
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="d-flex  flex-column justify-content-center align-items-center">
                            {value?.skills?.length ? <>

                                <Skills text={value?.skills[0].name} />
                                {value?.skills?.length > 1 ? <>
                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={ToolTip({ text: getSkills(value?.skills) })}>
                                        <Badge className="clickable bg-secondary" style={{ height: "fit-content" }} >+{value?.skills?.length - 1} more
                                        </Badge>
                                    </OverlayTrigger>
                                </> : null}
                            </> : null}
                        </div>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                        {action && action(value)}
                    </div>
                </div>
            </div>
        </div>
    }

    return (
        <div>
            <div className="job-list-container-div">
                <div className="job-list-div">

                    {jobList.map((value: any, i: number) => (
                        <div
                            className={`job-entry ${selectedJobId === value._id ? 'selected-job-entry' : ''}`}
                            onClick={() => onJobSelect(value)}
                            key={i}
                        >
                            <div className="bigger-div">
                                <div className=" job-entry-logo ">
                                    <div className="job-logo rounded-3 shadow-sm" style={{ backgroundImage: `url('${value.companyImgUrl || DEFAULT_URL}')` }}></div>
                                </div>

                                <div className="job-entry-details">
                                    <div className="joblist-jobrole-name">{toSentenceCase(value?.jobRole?.name || "")}</div>
                                    <div className="joblist-company-name">{value.companyName}</div>
                                    <div className="location-and-salary">
                                        <div className=" location ">
                                            <Label text={toSentenceCase(value.location || "")} Icon={LocationIcon} />
                                        </div>
                                        <div className="salary">
                                            {value.showSalary ? <Label text={`${formatMoney(value?.salaryLowerAmount)}-${formatMoney(value?.salaryUpperAmount)}`} Icon={null} /> : <Label text={`N/A`} Icon={null} />}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </div>
    )

}



export function Label({ text, Icon, color, bgColor, placement = "bottom", classList = '' }: { text: string, Icon?: any, color?: string, bgColor?: string, placement?: Placement, classList?: string }) {
    return <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={placement} overlay={ToolTip({ text })}>
        <div className={`label-container ${classList}`} style={{ color: color || "var(--pink-shade)", background: bgColor || "#F7D3EA", maxWidth: '250px' }}>
            {Icon && <Icon className="pr-1 label-icon" />}
            <span className="label-text">{text}</span>
        </div>
    </OverlayTrigger>
}
export function Skills({ text }: { text: string }) {

    return <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"auto-start"} overlay={ToolTip({ text })}>
        <div className="skill-container" >
            {text}
        </div>
    </OverlayTrigger>

}

export function ToolTip({ text, ...rest }: any) {

    return <Tooltip id="button-tooltip" {...rest}>
        {text}
    </Tooltip>
}